import React from 'react';
import { ApolloProvider as ApolloProviderBase } from '@apollo/client';
import { apolloClient } from '../../../graphql/client';
import { ApolloErrorHandlingProvider } from './ApolloErrorHandlingProvider';

const ApolloProvider = ({ children }) => {
  return (
    <ApolloProviderBase client={apolloClient}>
        <ApolloErrorHandlingProvider>
            {children}
        </ApolloErrorHandlingProvider>
    </ApolloProviderBase>
  );
};

export default ApolloProvider;